import { render, staticRenderFns } from "./banner-text.vue?vue&type=template&id=0df6f956&scoped=true&"
import script from "./banner-text.vue?vue&type=script&lang=js&"
export * from "./banner-text.vue?vue&type=script&lang=js&"
import style0 from "./banner-text.vue?vue&type=style&index=0&id=0df6f956&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df6f956",
  null
  
)

export default component.exports